<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">コンテナ受入計画</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <date-picker
          label="月次指定"
          style="padding: 8px"
          type="month"
          @input="setMonth"
        ></date-picker>
        <v-btn :disabled="!this.year || !this.month" @click="load">検索</v-btn>
        <table-upload @input="importForcast" title="コンテナ受入計画登録" />
        <v-btn :disabled="!this.year || !this.month" @click="download"
          >計画差異</v-btn
        >
        <a @click="$downloadTemplate('ReserveForecast', 'excel')" href="#"
          >Excel template</a
        >
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-actions>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th v-for="d in dates" :key="d">{{ d.slice(8, 10) }}</th>
              <th>月合計</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th v-for="d in dates" :key="d">{{ weekOf(d) }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="w in warehouses" :key="w.code">
            <tr v-for="(g, idx) in w.productGroups" :key="w.code + g.name">
              <td
                v-if="idx === 0"
                :rowspan="w.productGroups.length"
                class="warehouse"
              >
                {{ w.chineseName }} <br />
                {{ w.code }}
              </td>
              <td style="text-align: right; border-right: 1px solid #f0f0f0">
                {{ g.name }}
              </td>
              <td v-for="d in dates" :key="w.code + g.name + d">
                {{ total('forecast', g.forecasts, d) | hiddenZero }} <br />
                <!-- {{ total('actual', g.forecasts, d) | hiddenZero }}<br />
                {{ total('diff', g.forecasts, d) | hiddenZero }} -->
              </td>
              <td>
                {{ total('forecast', g.forecasts) }}<br />
                <!-- {{ total('actual', g.forecasts) }} -->
              </td>
            </tr>
            <tr class="subtotal">
              <td
                colspan="2"
                style="text-align: right; border-right: 1px solid #f0f0f0"
              >
                計
              </td>
              <td v-for="d in dates" :key="w.code + 'subTotal' + d">
                {{ total('forecast', w.forecasts, d) }}<br />
                <!-- {{ total('actual', w.forecasts, d) }} -->
              </td>
              <td>
                {{ total('forecast', w.forecasts) }}<br />
                <!-- {{ total('actual', w.forecasts) }} -->
              </td>
            </tr>
          </tbody>
          <tbody v-for="wg in warehouseGroups" :key="wg.name">
            <tr v-for="(g, idx) in wg.productGroups" :key="wg.name + g.name">
              <td
                v-if="idx === 0"
                :rowspan="wg.productGroups.length"
                class="warehouse"
                style="width: 80px"
              >
                {{ wg.name }}
              </td>
              <td style="text-align: right; border-right: 1px solid #f0f0f0">
                {{ g.name }}
              </td>
              <td v-for="d in dates" :key="wg.name + g.name + d">
                {{ total('forecast', g.forecasts, d) | hiddenZero }}<br />
                <!-- {{ total('actual', g.forecasts, d) | hiddenZero }} -->
              </td>
              <td>
                {{ total('forecast', g.forecasts) }}<br />
                <!-- {{ total('actual', g.forecasts) }} -->
              </td>
            </tr>
            <tr class="subtotal">
              <td
                colspan="2"
                style="text-align: right; border-right: 1px solid #f0f0f0"
              >
                計
              </td>
              <td v-for="d in dates" :key="wg.name + 'subTotal' + d">
                {{ total('forecast', wg.forecasts, d) }}<br />
                <!-- {{ total('actual', wg.forecasts, d) }} -->
              </td>
              <td>
                {{ total('forecast', wg.forecasts) }}<br />
                <!-- {{ total('actual', wg.forecasts) }} -->
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="(g, idx) in productGroups" :key="'all' + g.name">
              <td
                v-if="idx === 0"
                :rowspan="productGroups.length"
                class="warehouse"
                style="width: 80px"
              >
                合計
              </td>
              <td style="text-align: right; border-right: 1px solid #f0f0f0">
                {{ g.name }}
              </td>
              <td v-for="d in dates" :key="'all' + g + d">
                {{ total('forecast', g.forecasts, d) | hiddenZero }}<br />
                <!-- {{ total('actual', g.forecasts, d) | hiddenZero }} -->
              </td>
              <td>
                {{ total('forecast', g.forecasts) }}<br />
                <!-- {{ total('actual', g.forecasts) }} -->
              </td>
            </tr>
            <tr class="subtotal">
              <td
                colspan="2"
                style="text-align: right; border-right: 1px solid #f0f0f0"
              >
                計
              </td>
              <td v-for="d in dates" :key="'all' + 'subTotal' + d">
                {{ total('forecast', result, d) }}<br />
                <!-- {{ total('actual', result, d) }} -->
              </td>
              <td>
                {{ total('forecast', result) }}<br />
                <!-- {{ total('actual', result) }} -->
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-actions>
    </v-card>
    <progress-dlg ref="progressDlg" />
  </v-container>
</template>

<script>
import ProgressDlg from '../../components/ProgressDlg.vue'
export default {
  components: {
    ProgressDlg,
  },

  data() {
    return {
      year: null,
      month: null,
      result: [],
      headers: [],
      dates: [],
      from: null,
      to: null,
      warehouses: [],
      warehouseGroups: [],
      productGroups: [],
      errors: {
        EMPTY_FORECAST_LOAD: '当該月分のコンテナ受入計画が登録されていない',
        EMPTY_FORECAST:
          '当該月分のコンテナ受入計画が登録されていないので、計画差異帳票がダウンロードできません。',
        NOT_FULL_MONTH: '日付不備があるので、アップロードが失敗になります。',
      },
    }
  },

  computed: {
    allProductGroups() {
      return this.result.reduce((t, r) => {
        if (!t.includes(r.productGroup)) t.push(r.productGroup)
        return t
      }, [])
    },
  },
  filters: {
    hiddenZero: function(value) {
      return value === 0 ? '-' : value
    },
  },
  methods: {
    clearData() {
      this.warehouses = []
      this.warehouseGroups = []
      this.productGroups = []
      this.result = []
    },
    weekOf(date) {
      return '日月火水木金土'[new Date(date).getDay()]
    },
    download() {
      this.$download('/warehouse-container-settings/forecasts/xlsx', {
        from: this.from,
        to: this.to,
      }).catch((err) => {
        let data = err.response.data
        if (err.request.responseType === 'blob') {
          var that = this
          var reader = new FileReader()
          reader.readAsText(data, 'utf-8')
          reader.onload = function() {
            data = JSON.parse(reader.result)
            console.log(data)
            if ('EMPTY_FORECAST' === data.message) {
              that.$message(
                'ERROR',
                '当該月分のコンテナ受入計画が登録されていないので、計画差異帳票がダウンロードできません。'
              )
            }
          }
        }
      })
    },
    setMonth(value) {
      this.clearData()
      this.year = value.slice(0, 4)
      this.month = value.slice(5, 7)
      let to = new Date(this.year, this.month, 0)
      this.dates = Array.from(
        {
          length: to.getDate(),
        },
        (v, i) => value + '-' + (i < 9 ? '0' + (i + 1) : i + 1)
      )
      this.from = this.dates[0]
      this.to = this.dates[this.dates.length - 1]
    },

    total(type, forecasts, date) {
      if (date) {
        forecasts = forecasts.filter((r) => r.reserveDate === date)
      }
      return forecasts.map((r) => r[type]).reduce((t, a) => t + a, 0)
    },

    getProductGroups(forecasts) {
      return forecasts.reduce((t, r) => {
        var pg = t.find((pg) => pg.name === r.productGroup)
        if (!pg) {
          pg = {
            name: r.productGroup,
            forecasts: [],
          }
          t.push(pg)
        }
        pg.forecasts.push(r)
        return t
      }, [])
    },
    getActDate(year, month, day) {
      return year + '-' + month + '-' + day
    },
    importForcast(data) {
      let values = []

      console.log(data)

      let year = data[0][0]
      let month = data[0][1]

      var dates = []
      for (var d = 2; d < data[0].length; d++) {
        if (dates.indexOf(data[0][d]) === -1) {
          dates.push(data[0][d])
        }
      }
      console.log('dates', dates)

      if (!this.validDate(year, month, dates.length)) {
        this.$message('', '日付不備があるので、アップロードが失敗になります。')
        return
      }

      let a, b

      for (let i = 2; i < data.length; i++) {
        if (!a) {
          a = data[i][0]
        }
        b = data[i][1]
        if (b === '計') {
          a = undefined
          continue
        }
        for (let j = 2; j < data[0].length; j++) {
          let amount = parseInt(data[i][j] || 0)
          values.push({
            code: a,
            row: i,
            col: j,
            productGroup: b,
            reserveDate: this.getActDate(year, month, data[0][j]),
            forecast: amount,
          })
        }
      }
      console.log('values:', values)

      let from = this.getActDate(year, month, data[0][2])
      let to = this.getActDate(year, month, data[0][data[0].length - 1])
      console.log(from, to)
      this.$http
        .delete('/warehouse-container-settings/forecast', {
          params: {
            from,
            to,
          },
        })
        .then(() => {
          let size = 100
          let page = Math.ceil(values.length / size)
          this.$refs.progressDlg.setTotal(page)
          for (let i = 0; i < values.length; i += size) {
            this.$http
              .post(
                '/warehouse-container-settings/forecast',
                values.slice(i, i + size),
                {
                  quiet: true,
                }
              )
              .then(() => {
                this.$refs.progressDlg.tick()
              })
              .catch((err) => {
                this.$message(
                  '',
                  '日付不備があるので、アップロードが失敗になります。'
                )
                this.$refs.progressDlg.tick()
              })
          }
        })
        .catch((err) => {
          this.$message(
            '',
            '日付不備があるので、アップロードが失敗になります。'
          )
        })
    },
    validDate(year, month, days) {
      var d = new Date(year, month, 0)
      if (days < d.getDate()) {
        return false
      }
      return true
    },
    load() {
      this.clearData()
      this.$http
        .get('/warehouse-container-settings/forecasts', {
          params: {
            from: this.from,
            to: this.to,
          },
        })
        .then((res) => {
          this.result = res.data
          this.warehouses = this.result
            .reduce((t, d) => {
              var wh = t.find((w) => w.code == d.code)
              if (!wh) {
                wh = {
                  code: d.code,
                  name: d.name,
                  forecasts: [],
                }
                t.push(wh)
              }
              wh.forecasts.push(d)
              return t
            }, [])
            .map((w) => {
              return {
                ...w,
                productGroups: this.getProductGroups(w.forecasts),
              }
            })
          this.warehouseGroups = this.result
            .reduce((t, d) => {
              var group = t.find((g) => g.name === d.warehouseGroup)
              if (!group) {
                group = {
                  name: d.warehouseGroup,
                  forecasts: [],
                }
                t.push(group)
              }
              group.forecasts.push(d)
              return t
            }, [])
            .map((wg) => {
              return {
                ...wg,
                productGroups: this.getProductGroups(wg.forecasts),
              }
            })
          this.productGroups = this.getProductGroups(this.result)
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
  },
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

th {
  padding: 2px;
  white-space: nowrap;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}

td {
  padding: 2px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

td.warehouse {
  width: 60px;
  white-space: normal;
}

tr.subtotal {
  background: #f0f0f0;
}
</style>
